<template>
  <div>
    <!-- <CRow>
      <CCol lg="12">
        <GlobalTable
          :title="title + ' List'"
          :fields="fields"
          :items="items"
          :editButton="true"
          :redirectDetail="true"
          :isLoading="isLoading"
          :enableAddButton="false"
        ></GlobalTable>
      </CCol>
    </CRow> -->

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :listBoxSource="listBoxSource"
                :visibilityShow="visibilityShow"
                :addButtonNeed="false"
                :title="title"
                @showHide="showHide"
                @exportXls="exportXls"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :localization="localization"
                    :selectionmode="''"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
// import GlobalTable from "@/templates/Table";
import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

export default {
  name: "UserRequestFreezer",
  components: { Loading, JqxGrid, TableButton },
  data() {
    return {
      title: "User Request Freezer",
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "request_code", type: "string" },
          { name: "user_code", type: "string" },
          { name: "user_name", type: "string" },
          { name: "email", type: "string" },
          { name: "mobile_phone", type: "string" },
          { name: "group_name", type: "string" },
          { name: "type_user_name", type: "string" },
          { name: "province_name", type: "string" },
          { name: "regencies_name", type: "string" },
          { name: "district_name", type: "string" },
          { name: "villages_name", type: "string" },
          { name: "status_name", type: "string" },
          { name: "date_inserted", type: "date" },
        ],
        datatype: "json",
      },
      editrow: -1,

      fields: [
        { key: "request_code", label: "Request Code", sorter: true },
        { key: "user_code", label: "User Code", sorter: true },
        { key: "user_name", label: "Customer Name", sorter: true },
        { key: "email", label: "Email", sorter: true },
        { key: "mobile_phone", label: "Mobile Phone", sorter: true },
        { key: "group_name", label: "Customer Group", sorter: true },
        { key: "type_user_name", label: "Customer Type", sorter: true },
        { key: "province_name", label: "Province", sorter: true },
        { key: "regencies_name", label: "Regencies", sorter: true },
        { key: "district_name", label: "District", sorter: true },
        { key: "villages_name", label: "Villages", sorter: true },
        { key: "date_inserted", label: "Date Inserted", sorter: true },
        { key: "status_name", label: "Status", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],

      fields: [
        {
          datafield: "request_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Request Code",
        },
        {
          datafield: "user_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "User Code",
        },
        {
          datafield: "user_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Customer Name",
        },
        {
          datafield: "email",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Email",
        },
        {
          datafield: "mobile_phone",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Mobile Phone",
        },
         {
          datafield: "status_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Status",
        },
        {
          datafield: "province_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Province",
          hidden: true,
        },
        {
          datafield: "regencies_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Regencies",
          hidden: true,
        },
        {
          datafield: "district_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "District",
          hidden: true,
        },
        {
          datafield: "villages_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Villages",
          hidden: true,
        },
        {
          datafield: "date_inserted",
          columntype: "datetimeinput",
          filtertype: "date",
          text: "Date Inserted",
          cellsformat: "d",
          cellsalign: "right",
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        },
      ],

      listBoxSource: [
        {
          label: "Province",
          value: "province_name",
          checked: false,
        },
         {
          label: "Regencies",
          value: "regencies_name",
          checked: false,
        },
         {
          label: "District",
          value: "district_name",
          checked: false,
        },
         {
          label: "Villages",
          value: "villages_name",
          checked: false,
        },
      ],

      items: null,
      isLoading: false,

      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.getUserRequestFreezer();
    },
    getUserRequestFreezer: function () {
      this.isLoading = true;
      this.axios
        .get("console/request_freezer/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            //this.items = response.data.data;
            // console.log(response.data.data);
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
